import { action } from '../reduxHelpers';
import { ITEM_DATA } from './actionTypes';

const loadItemData = (gtin, supc) => action(ITEM_DATA.REQUEST, { gtin, supc });

export { loadItemData };
